<div class="main-container">
    <div class="container">

        <div class="card">
            <mat-card>
                <mat-card-header>
                    <mat-card-title>{{userData.name | titlecase}} {{userData.lastname |titlecase}} bienvenido/a al
                        reclutamiento de Tumsa</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p>Muchas gracias por participar en el proceso de reclutamiento como operador de Tumsa</p>
                    <p>A partir de este momento comenzará tu examen, en el que evaluaremos tus habilidades como
                        conductor de
                        transporte de carga</p>
                    <p>Comenzaremos por configurar tu perfil, por lo que será necesario tomar una foto de tu cara. Si
                        utilizas lentes o gorra por favor quitalos mientras te tomas la foto</p>
                    <p>Si tienes alguna duda durante el examen por favor pide ayuda a alguno de los reclutadores</p>

                    <p>Recuerda que no está permitido el uso de celular asi que toma en cuenta que no podras utilizarlo
                        durante al menos un par de horas</p>

                    <p>En nombre de Tumsa te deseamos éxito</p>
                </mat-card-content>
            </mat-card>
        </div>

        <div (click)="nextPage()" class="sendbutton mat-elevation-z4" matRipple [matRippleRadius]="300"
            [matRippleColor]="'rgb(255, 87, 118, 0.3)'">
            <span class="buttontext">Tomar Foto</span>
        </div>

    </div>
</div>